import { components } from 'services/api/lna-api-v2.schema';

export type UserSecurityInfoModel = components['schemas']['UserSecurityInfoModel'];
export type UserStructuralUnitModel = components['schemas']['UserStructuralUnitModel'];
export type UserInfoModel = components['schemas']['UserInfoModel'];
export type UserListItem = components['schemas']['UserListItem'];
export type UserCard = components['schemas']['UserCard'];
export type UpdateUserRequest = components['schemas']['UpdateUserRequest'];

export type UserListItemPagedResponse = components['schemas']['UserListItemPagedResponse'];
export type PolicyType = components['schemas']['PolicyType'];
export type AppClaimType = components['schemas']['AppClaimType'];
export type UserMinimalListItem = components['schemas']['UserMinimalListItem'];

//Membership
export type UserCardMembershipItem = components['schemas']['UserCardMembershipItem'];
export type UpdateUserMembershipItem = components['schemas']['UpdateUserMembershipItem'];

//Notification
export type UserNotificationListUserItem = components['schemas']['UserNotificationListUserItem'];
export type UserNotificationCard = components['schemas']['UserNotificationCard'];
export type CreateUserNotificationRequest = components['schemas']['CreateUserNotificationRequest'];
export type UpdateUserNotificationRequest = components['schemas']['UpdateUserNotificationRequest'];
export type UserNotificationListItem = components['schemas']['UpdateUserNotificationRequest'];
export type UserNotificationListItemPagedResponse = components['schemas']['UserNotificationListItemPagedResponse'];
export type UpdateUserNotificationIsReadRequest = components['schemas']['UpdateUserNotificationIsReadRequest'];
export type UserNotificationListByUserIdUserItem = components['schemas']['UserNotificationListByUserIdUserItem'];
export type UserNotificationListByUserIdItemPagedResponse = components['schemas']['UserNotificationListByUserIdItemPagedResponse'];
export type UserNotificationListByUserIdItem = components['schemas']['UserNotificationListByUserIdItem'];

//Absence
export type UserAbsenceCard = components['schemas']['UserAbsenceCard'];
export type UserAbsenceCardUserItem = components['schemas']['UserAbsenceCardUserItem'];
export type UserAbsenceListByIdUserItem = components['schemas']['UserAbsenceListByIdUserItem'];
export type UserAbsenceListUserItem = components['schemas']['UserAbsenceListUserItem'];
export type UserAbsenceListByIdItem = components['schemas']['UserAbsenceListByIdItem'];
export type UserAbsenceListItem = components['schemas']['UserAbsenceListItem'];
export type UpdateUserAbsenceRequest = components['schemas']['UpdateUserAbsenceRequest'];
export type UserAbsenceListItemPagedResponse = components['schemas']['UserAbsenceListItemPagedResponse'];
export type CreateUserAbsenceRequest = components['schemas']['CreateUserAbsenceRequest'];
export interface AbsenceFormItem {
  id?: string;
  isHistoric?: boolean;
  periodStart: string;
  periodEnd: string | null;
  substituteUserId: string;
  createdByUserId?: string;
  applicantUserId?: string;
}

export enum ActivationStatus {
  New = 'New',
  Active = 'Active',
  Inactive = 'Blocked'
}

export enum NotificationStatus {
  Read = 'true',
  Unread = 'false'
}

export enum AttendanceStatus {
  Attended = 'Attended',
  NotAttended = 'NotAttended',
  Unknown = 'Unknown'
}

type AppClaimTypes = {
  [key: string]: AppClaimType;
};

type AppClaimScopes = {
  [key: string]: PolicyType;
};

export const CLAIM_TYPES: AppClaimTypes = {
  edit: 'Edit',
  delete: 'Delete',
  create: 'Create',
  update: 'Update',
  read: 'Read',
  manager: 'Manager',
  updateOwned: 'UpdateOwned',
  cmsPortalContent: 'CMSPortalContent',
  cmsBackgroundImage: 'CMSBackgroundImage',
  cmsUserManuals: 'CMSUserManuals',
  cmsPopularSearches: 'CMSPopularSearches',
  workspaceNotifications: 'WorkspaceNotifications',
  workspaceMyServiceSubmissions: 'WorkspaceMyServiceSubmissions',
  workspaceStructuralUnitServiceSubmissions: 'WorkspaceStructuralUnitServiceSubmissions',
  workspaceAllServiceSubmissions: 'WorkspaceAllServiceSubmissions',
  workspaceMyInformationRequests: 'WorkspaceMyInformationRequests',
  workspaceStructuralUnitInformationRequests: 'WorkspaceStructuralUnitInformationRequests',
  workspaceAllInformationRequests: 'WorkspaceAllInformationRequests'
};

export const CLAIM_SCOPES: AppClaimScopes = {
  classifier: 'Classifier',
  tooltip: 'Tooltip',
  role: 'Role',
  structuralUnit: 'StructuralUnit',
  user: 'User',
  bgJobs: 'BgJobs',
  audit: 'Audit',
  notification: 'Notification',
  serviceConfig: 'ServiceConfig',
  cms: 'CMS',
  absence: 'Absence',
  client: 'Client',
  readingRoom: 'ReadingRoom',
  serviceSubmission: 'ServiceSubmission',
  informationRequest: 'InformationRequest',
  informationRequestNote: 'InformationRequestNote',
  myWorkspace: 'MyWorkspace',
  myProfile: 'MyProfile',
  feedback: 'Feedback'
};
